import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'recommendations',
    label: 'Recommendations',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
